export const DEAL_STATUS_NEW = 1501;
export const DEAL_STATUS_APPROVED = 1502;
export const DEAL_STATUS_SIGNED = 1515;
